/*
 * Author: Ben Zhao
 * File Created: Thursday, 25-01-16 10:47 am
 * Last Modified: Friday, 25-01-17 12:05 pm, by Ben Zhao
 */

import type { ReactNode } from 'react';
import { useLayoutEffect, useRef, useState } from 'react';

import { motion } from 'framer-motion';

import { Typography } from '@mui/material';

import { IconBox } from './style';

interface FixedContactorProps {
  bottom: number | string;
  expandText: string;
  icon?: ReactNode;
  onClick?: () => void;
}

const FixedContactor: React.FC<FixedContactorProps> = ({
  bottom,
  expandText,
  icon,
  onClick,
}) => {
  const textRef = useRef<HTMLSpanElement>(null);

  const [targetTextWidth, setTargetTextWidth] = useState(0);

  useLayoutEffect(() => {
    if (textRef.current) {
      const width = textRef.current.getBoundingClientRect().width;

      setTargetTextWidth(width);
    }
  }, [expandText]);

  return (
    <motion.div
      animate={{ opacity: 1 }}
      initial={{ opacity: 0 }}
      style={{
        position: 'fixed',
        bottom: typeof bottom === 'number' ? `${bottom}px` : bottom,
        right: '30px',
        zIndex: 999,
      }}
      transition={{ duration: 0.5, delay: 2 }}>
      <IconBox onClick={onClick} targetTextWidth={targetTextWidth}>
        {icon}
        <Typography>{expandText}</Typography>
        <Typography
          ref={textRef}
          sx={{
            left: '9999px',
            position: 'absolute',
            width: 'fit-content !important',
          }}>
          {expandText}
        </Typography>
      </IconBox>
    </motion.div>
  );
};

export default FixedContactor;
